import axios from "axios";
import { setupInterceptorsTo } from "./interceptors";

const baseURL = () => {
  const environment = process.env.REACT_APP_ENV;
  switch (environment) {
    case "LOCAL":
      return process.env.REACT_APP_API_URL;
    case "STAGE":
      return process.env.REACT_APP_PE_URL_STAGE;
    case "DEV":
      return process.env.REACT_APP_PE_URL_DEV;
    default:
      return process.env.REACT_APP_API_URL;
  }
};

const axiosInstance = axios.create({
  baseURL: baseURL(),
  headers: {
    "Content-Type": "application/json",
  },
});

setupInterceptorsTo(axiosInstance);

export default axiosInstance;
